function Config() {
    let BASE_URL = process.env.REACT_APP_CC_BASE_URL;
    return BASE_URL;
}

export default Config;
